// GENERATED by scripts/gen-site-counts.mjs. Do not edit by hand.
// Re-run `npm run gen:counts` after adding content to a registry.
export const SITE_COUNTS = {
  "articles": 263,
  "helpArticles": 120,
  "guides": 31,
  "caseStudies": 13,
  "competitors": 33,
  "alternatives": 7,
  "freeTools": 38,
  "platforms": 10,
  "playbooks": 3,
  "downloads": 23
} as const
